// features/template.validation.js

export const getTemplateValidation = (isEditing = false) => ({
  template_key: (value, formData) => {
    const isMarketing = formData?.mailing_for === "MARKETING";
    if (!isEditing && !isMarketing && !value?.trim()) return "Template key is required.";
    return "";
  },

  template_name: (value) => {
    if (!value?.trim()) return "Template name is required.";
    return "";
  },

  subject: (value) => {
    if (!value?.trim()) return "Subject is required.";
    return "";
  },

  body_html: (value) => {
    if (!value?.trim()) return "Body HTML is required.";
    return "";
  },
});
